import css from 'styled-jsx/css';
import typography from '../../../../styles/typography';

export const styles = css`
  .BigProductCardFixedHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 80px;
    padding: 0 40px;
    background-color: var(--colors-white);
    border-bottom: solid 1px var(--colors-brandLightGrey1);
  }
  .BigProductCardFixedHeader__image {
    max-width: 40px;
    max-height: 40px;
    height: auto;
  }
  .BigProductCardFixedHeader__title {
    ${typography.h6}
    width: 220px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .BigProductCardFixedHeader__addButton {
    width: 195px;
    height: 40px;
  }
  .BigProductCardFixedHeader__weight {
    color: var(--colors-darkenGrey1);
  }
  .BigProductCardFixedHeader__price {
    margin-bottom: 0;
    line-height: 21px;
  }
  .BigProductCardFixedHeader__buttonContainer {
    min-width: 190px;
    display: flex;
    align-items: center;
  }
  .BigProductCardFixedHeader__addToCartCardButton {
    width: 234px;
    margin-right: 5px;
  }
  `;
